import React from "react";
import Svg, { Path } from "react-native-svg";

import { DietaryMark, type DietaryIconProps } from "./DietaryMark";

/** FSSAI veg mark — a green dot in a green square, on its native 16×16 grid. */
export function VegIcon({ size = 14 }: DietaryIconProps) {
  return (
    <DietaryMark size={size} label="Vegetarian">
      <Svg width={size} height={size} viewBox="0 0 16 16" fill="none">
        <Path
          d="M12.2857 2H3.71429C2.76751 2 2 2.76751 2 3.71429V12.2857C2 13.2325 2.76751 14 3.71429 14H12.2857C13.2325 14 14 13.2325 14 12.2857V3.71429C14 2.76751 13.2325 2 12.2857 2Z"
          stroke="#22863A"
          strokeWidth={1.3125}
        />
        <Path
          d="M7.99986 11.4294C9.89341 11.4294 11.4284 9.89438 11.4284 8.00084C11.4284 6.10729 9.89341 4.57227 7.99986 4.57227C6.10631 4.57227 4.57129 6.10729 4.57129 8.00084C4.57129 9.89438 6.10631 11.4294 7.99986 11.4294Z"
          fill="#22863A"
        />
      </Svg>
    </DietaryMark>
  );
}
VegIcon.displayName = "VegIcon";
export default VegIcon;
